const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/measurements/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/measurements/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getMeasurementsOverviewQuery } from '@/features/body-measurements/lib/get-measurements-overview.query';
import { listBodyMetricsQuery } from '@/features/body-measurements/lib/list-body-metrics.query';
import { MeasurementsSkeleton } from '@/features/body-measurements/ui/measurements-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/measurements/')({
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        bodyMeasurementsController: context.deps.controllers.bodyMeasurementsController
      }
    };
    try {
      await context.queryClient.ensureQueryData(getMeasurementsOverviewQuery(deps));
      // Warms the manage-metrics sheet; not awaited so it never blocks the page.
      void context.queryClient.prefetchQuery(listBodyMetricsQuery(deps));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: MeasurementsSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});